import { FC } from "react";

import { ManageSectionPagesContent } from "./ManageSectionPagesContent";

import { CloseOverlayButton } from "components/materials/sidebar/CloseOverlayButton";
import { ContentSidebarHeader } from "components/materials/sidebar/ContentSidebarHeader";
import { ContentSidebarMain } from "components/materials/sidebar/ContentSidebarMain";
import { OverlayContainer } from "components/materials/sidebar/OverlayContainer";
import { t } from "i18n/i18n";
import { useNavigate, useQueryParamsManager } from "utils/routing";

export const ManageSectionPagesMobilePanel: FC = () => {
  const navigate = useNavigate();
  const { deleteQueryParams } = useQueryParamsManager();

  const onPageClick = (href: string) => {
    deleteQueryParams(["overlay"]);
    navigate(href);
  };

  return (
    <OverlayContainer>
      <ContentSidebarHeader panelType="overlay" visibleOnMobile>
        <h3 className="text-black-tint-10">{t("manage_section_pages_modal.title")}</h3>
        <CloseOverlayButton />
      </ContentSidebarHeader>

      <ContentSidebarMain>
        <ManageSectionPagesContent onPageClick={onPageClick} />
      </ContentSidebarMain>
    </OverlayContainer>
  );
};
